export default __webpack_public_path__ + "static/media/uploaderBtn.624bfd79.svg";